import { render, staticRenderFns } from "./WorklogDetailsDialog.vue?vue&type=template&id=2347fadf&"
import script from "./WorklogDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./WorklogDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports